import { FieldOptionBase } from 'module/api/field/types';
import { byLabel } from 'module/helpers/comparators/by-label';
import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import { ClassNameOnlyProps } from 'module/types/common';
import { MultiSelectField } from 'module/types/filter-field/field/filterable-field';
import { FC, ReactNode, RefObject, useCallback } from 'react';
import StateManager from 'react-select';
import styled from 'styled-components';
import { Popover, Select } from '../components/components';

type Props = ClassNameOnlyProps & {
  field: MultiSelectField;
  title: ReactNode;
  onChange: (latest: number[]) => void;
  selectRef: RefObject<StateManager>;
};

const StyledPopover = styled(Popover)`
  height: 448px;
`;

export const ControlledMultiSelectFieldEditorPopover: FC<
  React.PropsWithChildren<Props>
> = ({ field, title, onChange, selectRef, className }) => {
  const {
    options: { activeOptions, allOptions },
  } = optionsTransformer(field);
  const onValueChange = useCallback(
    (latest: FieldOptionBase[]) =>
      onChange?.((latest ?? []).sort(byLabel).map((x) => x.value)),
    [onChange],
  );

  return (
    <StyledPopover className={className}>
      <Popover.Title>{title}</Popover.Title>
      <Select
        ref={selectRef}
        type="tag"
        isMulti
        options={activeOptions}
        value={allOptions.filter((x) => (field.value ?? []).includes(x.value))}
        onChange={onValueChange}
      />
    </StyledPopover>
  );
};
